import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import api from './api';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Costs from './pages/Costs';
import Revenue from './pages/Revenue';
import Server from './pages/Server';
import Admin from './pages/Admin';
import EuGrant from './pages/EuGrant';
import Trips from './pages/Trips';
import Finance from './pages/Finance';
import PromoCodes from './pages/PromoCodes';
import Analytics from './pages/Analytics';
import Comped from './pages/Comped';
import Logs from './pages/Logs';
import ActivityMap from './pages/ActivityMap';
import UserActivity from './pages/UserActivity';
import TopPoiUsers from './pages/TopPoiUsers';
import CustomPois from './pages/CustomPois';
import POIQuality from './pages/POIQuality';
import BusinessIntel from './pages/BusinessIntel';
import SystemEvents from './pages/SystemEvents';
import PushStats from './pages/PushStats';
import PushSend from './pages/PushSend';
import Affiliates from './pages/Affiliates';
import PartnerPerformance from './pages/PartnerPerformance';
import TTSStudio from './pages/TTSStudio';
import Registrations from './pages/Registrations';
import ApiCredits from './pages/ApiCredits';
import Reviews from './pages/Reviews';
import ServerPro from './pages/ServerPro';
import Narrations from './pages/Narrations';
import Quality from './pages/Quality';
import Gnss from './pages/Gnss';
import MonthlyTrends from './pages/MonthlyTrends';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.me().then(u => setUser(u)).catch(() => setUser(null)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#00d4ff' }}>Betöltés...</div>;

  if (!user) return <Login onLogin={setUser} />;

  return (
    <BrowserRouter>
      <Layout user={user} onLogout={() => { api.logout(); setUser(null); }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/costs" element={<Costs />} />
          <Route path="/revenue" element={<Revenue />} />
          <Route path="/server" element={<Server />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/eu-grant" element={<EuGrant />} />
          <Route path="/trips" element={<Trips />} />
          <Route path="/finance" element={<Finance />} />
          <Route path="/promo" element={<PromoCodes />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/monthly-trends" element={<MonthlyTrends />} />
          <Route path="/comped" element={<Comped />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/push-stats" element={<PushStats />} />
          <Route path="/push-send" element={<PushSend />} />
          <Route path="/activity-map" element={<ActivityMap />} />
          <Route path="/user-activity" element={<UserActivity />} />
          <Route path="/poi-usage" element={<TopPoiUsers />} />
          <Route path="/custom-pois" element={<CustomPois />} />
          <Route path="/poi-quality" element={<POIQuality />} />
          <Route path="/business-intel" element={<BusinessIntel />} />
          <Route path="/affiliates" element={<Affiliates />} />
          <Route path="/affiliate-performance" element={<PartnerPerformance />} />
          <Route path="/system-events" element={<SystemEvents />} />
          <Route path="/tts" element={<TTSStudio />} />
          <Route path="/registrations" element={<Registrations />} />
          <Route path="/api-credits" element={<ApiCredits />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/server-pro" element={<ServerPro />} />
          <Route path="/narrations" element={<Narrations />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/gnss" element={<Gnss />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
